






















import { Component, Vue } from 'vue-property-decorator';

import { registrationUrl, generalInfo } from '@/store/fourth/store';

@Component({})
export default class Gotcha extends Vue {
  private registrationUrl = registrationUrl;
  private generalInfo = generalInfo;

  private register() {
    if (registrationUrl == null || registrationUrl.length < 5) {
      this.$message({
        showClose: true,
        message: '4월 3일(화) 오전 11시 오픈 예정입니다.',
        type: 'warning'
      });
    } else {
      window.open(registrationUrl, '_blank');
    }
  }
}
